import {
  TimelineEntry as SharedTimelineEntry,
  getTimelineIcon,
} from '@/components/Timeline';
import { cn } from '@/lib/utils';
import { User } from '@certhon/models';
import { ReactNode } from 'react';
import { EventDescription } from '../EventDescription';
import { ExtendedTicketEvent } from './timeline-utils';

interface TimelineEntryProps {
  event: ExtendedTicketEvent;
  user: User;
  isGroupStart: boolean;
  isLastEvent: boolean;
  previousTimestamp?: Date;
  eventActions?: ReactNode;
  children: ReactNode;
}

export function TimelineEntry({
  event,
  user,
  isGroupStart,
  isLastEvent,
  previousTimestamp,
  eventActions,
  children,
}: TimelineEntryProps) {
  const Icon = getTimelineIcon(event.type);
  return (
    <SharedTimelineEntry
      timestamp={event.created}
      previousTimestamp={previousTimestamp}
      user={user}
      isGroupStart={isGroupStart}
      isLastEvent={isLastEvent}
      icon={<Icon className={cn('text-muted-foreground/80 h-4 w-4')} />}
      description={<EventDescription user={user} event={event} />}
      eventActions={eventActions}
    >
      {children}
    </SharedTimelineEntry>
  );
}
